<template lang="html">
  <div class="start-xs h-100 overflow-y-scroll">
    <div class="pl-subheading tc ma4 assessment-title">
      Verbal Discussion Assessment
    </div>
    <button
      @click="closePage"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      class="exit-page ma2 absolute top-0 right-0 flex justify-center"
      :class="{ 'shadow-1': hovered }"
      style="margin: 30px"
    >
      <img
        style="max-width: 20px; vertical-align: middle"
        class="dib h3 w3"
        src="/static/close.svg"
        alt="close"
      />
      <p class="absolute italics" style="bottom: -35px">esc</p>
    </button>

    <div class="pl-subheading mt5">
      <span class="fw6">Assessment</span>
      <i
        v-my-tooltip="assessment_description"
        class="fa fa-info-circle"
        aria-hidden="true"
      />
    </div>
    <!-- Assessment Radio Selection Buttons -->
    <div class="radio-button-container">
      <div class="row" style="margin: 10px 10px 10px 0px">
        <pl-radio v-model="assessment_status" :value="false" />
        <span>No Assessment</span>
      </div>
      <div class="row" style="margin: 10px 10px 10px 0px">
        <pl-radio v-model="assessment_status" :value="true" />
        <span>Teacher can provide assessent with points</span>
      </div>
    </div>

    <div v-if="assessment_status">
      <!-- Scale Selection Container -->
      <div>
        <div class="pl-subheading mt4 flex items-center">
          <span class="fw6">Criteria Scale</span>

          <toggle-button
            @change="toggleCriteriaScale"
            :value="!!getCurrentDiscussion.point_cap"
            color="#72ccd7"
            :labels="false"
            class="mh3"
          />
          <i
            v-my-tooltip="scale_description"
            class="fa fa-info-circle"
            style="font-size: 12px"
            aria-hidden="true"
          />
        </div>
        <!-- Scale selection container -->
        <div v-if="point_scale !== null" class="mt3" style="margin-left: 6px">
          <pl-button
            class="pl-icon"
            style="display: inline-block"
            @click.native="point_scale -= 1"
            :disabled="Number(point_scale) === 0"
          >
            <i class="chevron clickable fa fa-chevron-left" />
          </pl-button>
          <pl-input
            @input="inputed"
            v-model="point_scale"
            :centeredText="true"
            :error="point_scale === ''"
            style="
              width: 50px;
              height: 23px;
              text-align: center;
              display: inline-block;
            "
          >
            {{ point_scale }}
          </pl-input>
          <pl-button
            class="pl-icon"
            style="display: inline-block"
            @click.native="addPoint"
          >
            <i class="chevron clickable fa fa-chevron-right" />
          </pl-button>
        </div>
      </div>

      <!-- List of Available Points to Teacher -->
      <div class="points-list-container mv4">
        <div class="pl-subheading">
          <span class="fw6">Criteria</span>
        </div>
        <div
          :key="`${index}-${point_type.title}`"
          v-for="(point_type, index) in available_point_types"
          class="individual-point-selection flex clickable selected-description"
        >
          <pl-checkbox
            v-model="selected_points"
            :value="point_type.tag"
            class="col-xs-1"
          />
          <strong class="col-xs-3"> {{ point_type.title }} </strong>
          <div class="col-xs-7">
            {{ formatPointDescription(point_type) }}
          </div>
          <div v-if="point_type.is_custom" class="clickable col-xs-1">
            <pl-menu :menuSize="2" direction="right">
              <pl-button slot="menu_trigger" class="pl-icon" style="margin: 0">
                <i class="fas fa-ellipsis-v" />
              </pl-button>
              <ul menu-content>
                <li @click="showPointCreationModal(point_type)">
                  <span>Edit</span>
                </li>
                <li @click="deletePoint(point_type)">
                  <span>Delete</span>
                </li>
              </ul>
            </pl-menu>
          </div>
        </div>
      </div>

      <!-- Create New Point Button -->
      <div
        @click="show_point_creation_modal = true"
        class="new-point-button clickable flex justify-center items-center ripple"
      >
        <i class="fa fa-plus" /> Create Assessment Point
      </div>
    </div>
    <!-- Save Changes - Button Row -->
    <div class="sticky-button-row flex items-center justify-between">
      <span class="col-xs-8">
        <span v-if="assessment_status">
          <span>
            You have Selected {{ selected_points.length }} assessment types
          </span>
        </span>
      </span>
      <pl-button
        v-if="have_points_changed"
        class="pl-primary"
        @click.native="updateAssessmentInformation"
      >
        Save Changes
      </pl-button>
      <pl-button @click.native="$emit('close')" v-else> Close </pl-button>
    </div>

    <!-- Modals -->
    <!-- Point Creation Modal -->
    <create-new-point-modal
      activityType="live"
      v-if="show_point_creation_modal"
      :rts="discussions_with_point"
      :tag="tag"
      @close="closePointModal"
    />

    <dialog-delete-confirm
      v-if="show_delete_point_modal"
      @close="show_delete_point_modal = false"
      @actionConfirmed="deleteAssessmentPoint"
      optionalText="Are you sure you want to delete this Point?"
    />

    <template v-if="show_alert_assessment_changing">
      <pl-dialog :maxWidth="'600px'" :padding="'2em'" class="center-xs">
        <div style="position: absolute; right: 0; top: 0">
          <pl-button
            @click.native="closeAssessmentChangingAlert"
            style="min-width: 0"
          >
            <strong class="f4">X</strong>
          </pl-button>
        </div>
        <div class="header pv3">
          <span class="pl-secondary b" style="font-size: 24px">
            Heads up!
          </span>
        </div>
        <div class="ph3" style="text-align: justify">
          <p>
            Changing (or deleting) this assessment criteria for this RoundTable
            will change (or delete) it for all of the other RoundTables in this
            course that also use this criteria:
          </p>
          <ul>
            <li
              class="b"
              v-for="discussion in displayCriteriaLds"
              :key="discussion.id"
            >
              {{ discussion.title }}
            </li>
          </ul>
        </div>
        <div class="pv2">
          <pl-button
            class="pl-primary"
            style="font-size: 16px"
            @click.native="closeAssessmentChangingAlert"
          >
            Okay, Got it.
          </pl-button>
        </div>
      </pl-dialog>
    </template>
  </div>
</template>

<script>
  // Modals
  import createNewPointModal from 'components/createNewPointModal.vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import filter from 'lodash/filter';
  import uniqBy from 'lodash/uniqBy';
  import find from 'lodash/find';
  import isEmpty from 'lodash/isEmpty';
  import xor from 'lodash/xor';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';

  export default {
    data() {
      return {
        show_point_creation_modal: false,
        hovered: false,
        selected_points: [],
        point_scale: 0,
        assessment_status: true,
        scale_description:
          'Use this number to identify a maximum value for each criteria in student assessments.',
        discussions_with_point: [],
        show_delete_point_modal: false,
        tag: null,
        delete_point_index: null,
        show_alert_assessment_changing: false,
      };
    },
    props: {
      activityType: {
        type: String,
        default: 'live',
      },
    },
    components: {
      createNewPointModal,
      dialogDeleteConfirm,
    },
    watch: {
      show_delete_point_modal() {
        if (this.show_delete_point_modal === false) {
          this.delete_point_index = null;
          this.discussions_with_point = [];
          this.tag = null;
        }
      },
      show_point_creation_modal() {
        if (this.show_point_creation_modal === false) {
          this.discussions_with_point = [];
          this.tag = null;
        }
      },
      getCurrentDiscussion() {
        this.selected_points =
          this.getCurrentDiscussion.points_settings.peer_rewards
            .filter((point) => point)
            .map((point) => point.tag);
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail', 'getCurrentDiscussion']),
      full_point_settings() {
        return this.selected_points.map((tag) =>
          find(this.available_point_types, (point) => point.tag === tag)
        );
      },
      available_point_types() {
        const coursePoints = filter(
          this.getCourseDetail.points_settings.peer_rewards,
          (reward) => {
            const { tag } = reward;
            const prefix = 'ld';
            return (
              tag.substring(0, 2) === prefix || tag.substring(0, 3) === 'all'
            );
          }
        );
        // Displays the point type if it's in the course detail OR in the RT
        return uniqBy(
          [
            ...coursePoints,
            ...this.getCurrentDiscussion.points_settings.peer_rewards,
          ],
          'tag'
        ).filter((point) => point);
      },
      // Used to display the save button
      have_points_changed() {
        const current_rt_point_tags =
          this.getCurrentDiscussion.points_settings.peer_rewards
            .filter((point) => point)
            .map((point) => point.tag);
        return (
          this.assessment_status !== this.getCurrentDiscussion.enable_grading ||
          !isEmpty(xor(this.selected_points, current_rt_point_tags)) ||
          this.point_scale !== this.getCurrentDiscussion.point_cap
        );
      },
      assessment_description() {
        const points =
          'Teachers and students can acknowledge \n' +
          'true greatness with Assessment Criteria';
        const scale =
          this.activityType === 'live'
            ? '<br /> <br /> You can even control the maximum \n' +
              'number of points a student can receive at a time'
            : '';
        return points + scale;
      },
      displayCriteriaLds() {
        return this.discussions_with_point.filter(
          (x) => x.id !== this.getCurrentDiscussion.id
        );
      },
    },
    methods: {
      // This action updates the roundtable
      updateAssessmentInformation() {
        // Dynamically fire actions
        this.$store.dispatch('saveLiveDiscussionSettings', {
          point_cap: this.point_scale,
          points_settings: this.full_point_settings,
          id: this.getCurrentDiscussion.id,
          enable_grading: this.assessment_status,
        });
        this.$store.dispatch('updateStudentPointSettings', {
          points_settings: this.full_point_settings,
        });
      },
      showPointCreationModal(point) {
        this.tag = point ? point.tag : null;
        this.checkDiscussionsWithPoint();
        if (!this.show_alert_assessment_changing) {
          this.show_point_creation_modal = true;
        }
      },
      closePointModal() {
        this.tag = null;
        this.show_point_creation_modal = false;
      },
      closeAssessmentChangingAlert() {
        this.show_alert_assessment_changing = false;
        if (this.delete_point_index) {
          this.show_delete_point_modal = true;
        } else {
          this.show_point_creation_modal = true;
        }
      },
      checkDiscussionsWithPoint() {
        const { tag } = this;
        const { live_discussions } = this.getCourseDetail;
        let result = [];
        for (let index = 0; index < live_discussions.length; index += 1) {
          const ld = live_discussions[index];
          const { peer_rewards } = ld.points_settings;
          const has_point = peer_rewards.find((p) => p.tag === tag);
          if (has_point) {
            result.push({ title: ld.title, id: ld.id });
          }
        }
        this.discussions_with_point = result;
        const only_current_discussion =
          this.discussions_with_point.length === 1
            ? this.discussions_with_point[0].id === this.getCurrentDiscussion.id
            : false;
        if (this.discussions_with_point.length && !only_current_discussion) {
          this.show_alert_assessment_changing = true;
        }
        return result;
      },
      deletePoint(point) {
        this.tag = point ? point.tag : null;
        this.delete_point_index =
          this.getCourseDetail.points_settings.peer_rewards.findIndex(
            (x) => x.tag == this.tag
          );
        this.checkDiscussionsWithPoint();
        if (!this.show_alert_assessment_changing) {
          this.show_delete_point_modal = true;
        }
      },
      async deleteAssessmentPoint() {
        let clonedCoursePointSettings = JSON.parse(
          JSON.stringify(this.getCourseDetail.points_settings.peer_rewards)
        );
        clonedCoursePointSettings.splice(this.delete_point_index, 1);
        let payload = [];
        if (this.discussions_with_point.length) {
          for (let i = 0; i < this.discussions_with_point.length; i += 1) {
            const ld = this.getCourseDetail.live_discussions.find(
              (r) => r.id === this.discussions_with_point[i].id
            );
            const index_ld = ld.points_settings.peer_rewards.findIndex(
              (x) => x.tag === this.tag
            );
            const peer_rewards = ld.points_settings.peer_rewards.slice();
            peer_rewards.splice(index_ld, 1);
            payload.push({ id: ld.id, peer_rewards });
          }
        }
        if (payload.length) {
          await this.$store.dispatch('updateRTsCriteria', {
            id: this.getCourseDetail.id,
            criterias: payload,
            activityType: 'live',
          });
          const currentLDChanged = payload.find(
            (x) => x.id === this.getCurrentDiscussion.id
          );
          if (currentLDChanged) {
            const { peer_rewards } = currentLDChanged;
            const cloned_ld = Object.assign({}, this.getCurrentDiscussion);
            cloned_ld.points_settings = { peer_rewards };
            this.$store.commit('UPDATE_LD_DETAILS', cloned_ld);
          }
        }
        this.$store
          .dispatch('updateCourseDetail', {
            id: this.getCourseDetail.id,
            points_settings: { peer_rewards: clonedCoursePointSettings },
          })
          .then(() => {
            this.show_delete_point_modal = false;
            EventBus.$emit(
              'toast-msg',
              'Assessment Criteria Point has been deleted.'
            );
          });
      },
      formatPointDescription(point) {
        const { description } = point;
        // Handle scenario where description can be an array or a string
        return Array.isArray(description)
          ? description.join('. ')
          : description;
      },
      closePage() {
        window.removeEventListener('keyup', this.escapeViewCommentPage);
        return this.$emit('close');
      },
      escapeViewCommentPage(event) {
        if (event.keyCode === 27) {
          this.closePage();
        }
      },
      toggleCriteriaScale(event) {
        this.point_scale = event.value
          ? this.getCurrentDiscussion.point_cap || 4
          : null;
      },
      inputed() {
        if (this.point_scale === '.') {
          this.point_scale = '';
        }
        if (this.point_scale === '' || this.point_scale < 0) {
          this.point_scale = '0';
        }
        if (isNaN(this.point_scale)) {
          this.point_scale = this.point_scale.slice(0, -1);
        } else {
          this.point_scale = this.point_scale.trim();
        }
      },
      addPoint() {
        if (this.point_scale === '') {
          this.point_scale = 1;
          return;
        }
        let decimal_places = 0;
        this.point_scale = String(this.point_scale);
        if (this.point_scale.split('.')[1])
          decimal_places = this.point_scale.split('.')[1].length;
        this.point_scale = Number.parseFloat(this.point_scale);
        this.point_scale += 1;
        if (this.point_scale > this.pointCap) {
          this.point_scale = this.pointCap;
        }

        this.point_scale = String(this.point_scale.toFixed(decimal_places));
      },
    },
    mounted() {
      // Set up the local state according to the current RT state
      window.addEventListener('keyup', this.escapeViewCommentPage);
      this.selected_points =
        this.getCurrentDiscussion.points_settings.peer_rewards
          .filter((point) => point)
          .map((point) => point.tag);
      this.assessment_status = this.getCurrentDiscussion.enable_grading;
      this.point_scale = this.getCurrentDiscussion.point_cap;
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'

  .exit-page
    border-radius: 50%;
    width: 70px;
    height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;

  .warning
    color: pl-ruby

  .sticky-button-row
    border-top: 2px solid pl-fog;
    position: sticky;
    // For safari
    position: -webkit-sticky;
    bottom: 0;
    background-color: white;
    padding: 10px 0px

  .individual-point-selection
    padding: 1em;
    overflow-wrap: break-word;
    &:hover
      background: alpha(pl-primary, 0.2)
  .fa-plus
    margin-right: 1em;
  .radio-button-container
    margin-left: 20px;
    margin-bottom: 15px;
  .new-point-button
    font-size: 16px;
    color: #808284;
    margin: 10px 0px;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    border: 1px solid #ECECEC;
    border-radius: 4px;
  .assessment-title
    font-size: 24px
    font-weight: 600
</style>



// WEBPACK FOOTER //
// editAssessmentPointsLD.vue?579d2d92